import React, { useEffect } from "react";
import { json, showDiscriminate } from "helpers/data";
import ServerImage from "components/server-image/server-image";
import { FavIcon } from "components/favIcon";
import Rating from "./rating";
import { ColoredLabel } from "components/classes";
import { Price } from "pages/details/app-detail.service";
import { useQuery } from "react-query";
import { client } from "helpers/client";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { create_app_wishList, delete_app_wishList } from "services/wishListServices";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";
import Download from "assets/images/svg/download_gray.svg";
import { useAuthContext } from "store/auth";


interface Props {
  versionId?: number;
  onVersionChange: (versionId: number) => void;
  appId: number;
  logo: string;
  title: string;
  label?: any | null;
  isLiked?: boolean;
  rating: number;
  price?: Price;
  numberOfRates: number;
  numberOfDownloads?: number;
}

function AppHeader({
  appId,
  logo,
  title,
  label,
  price,
  isLiked = false,
  rating,
  versionId,
  onVersionChange,
  numberOfRates = 0,
  numberOfDownloads = 0
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [{ user }] = useAuthContext();
  const { data: appVersions = [] } = useQuery<any[]>(
    ["app-versions", appId],
    () => client<any[]>(`/lookup/versions/getAll`, { params: { appId } }).then((r) => r.response ?? []),
    { enabled: !!appId }
  );
  const [favColor, setFavColor] = React.useState(isLiked || false);
  useEffect(() => {
    setFavColor(isLiked);
  }, [isLiked]);

  const handleFav = () => {
    setFavColor(!favColor);
    if (favColor) {
      removeAppsWishList();
    } else {
      handleAppsWishList();
    }
  };
  const handleAppsWishList = () => {
    const data = { customerId: user.Id, ApplicationId: appId };
    create_app_wishList(data)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.added"));
      })
      .catch();
  };
  const removeAppsWishList = () => {
    delete_app_wishList(appId)
      .then(({ response }) => {
        queryClient.invalidateQueries(["apps"]);
        if (response) toast.success(t("common:form.removed"));
      })
      .catch();
  };
  return (
    <div className="header">
      <div className="info">
        <ServerImage className="logo" src={logo} alt="logo" />
        <h1 className="title">{json(title)}</h1>

        {label && <ColoredLabel color={label?.color}>{json(label?.name)}</ColoredLabel>}

        <div className="div-rating">
          <span className="rating-num">{rating.toFixed(1)}</span>
          <Rating rating={rating} readOnly />
          <span className="all-rating">({numberOfRates})</span>
        </div>
        <div className="download">
          <img src={Download} alt="download" />
          <span>({numberOfDownloads})</span>
        </div>
        <button className="wishList" onClick={handleFav}>
          <FavIcon color={favColor} />
        </button>
        <Dropdown className="app-dropdown">
          <Dropdown.Toggle>{json(appVersions.find((v) => v.id === versionId)?.name ?? "")}</Dropdown.Toggle>
          <Dropdown.Menu>
            {appVersions.map((v: any) => (
              <Dropdown.Item value={v.id} key={v.id} onClick={() => onVersionChange(v.id)}>
                {json(v.name)}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {price && price?.netPrice > 0 ? (
        <div className="price">
          <p>
            {!!price?.discountPercentage && (
              <>
                <span className="from"> {t("details:addonDetails.from")} </span>
                <span className="old">{price?.priceBeforeDiscount}</span>
              </>
            )}
          
            <span className="newPrice">
              {price?.netPrice} 
              <span>
                {json(`${price?.currencySymbol}`)} / {json(`${showDiscriminate(`${price?.discrimination}`)}`)} 
              </span>
            </span>
          </p>
          <button className="btn-blue" onClick={() => navigate(`/pricing-plans/${appId}`)}>
            {t("details:addonDetails.buyNow")}
          </button>
        </div>
      ) : (
        <div className="price align-items-center">
          {/* <p>
            <span className="from">Not Available</span>
          </p> */}
          <button className="btn-blue" disabled>
            {t("details:addonDetails.buyNow")}
          </button>
        </div>
      )}
    </div>
  );
}

export default AppHeader;
